import { render, staticRenderFns } from "./KeyboardShortcutsInfo.vue?vue&type=template&id=02bca712&scoped=true&lang=pug"
import script from "./KeyboardShortcutsInfo.vue?vue&type=script&lang=js"
export * from "./KeyboardShortcutsInfo.vue?vue&type=script&lang=js"
import style0 from "./KeyboardShortcutsInfo.vue?vue&type=style&index=0&id=02bca712&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bca712",
  null
  
)

export default component.exports